export default "__VITE_ASSET__1e9eb2b0__"